import React from 'react';
import { Text, TextProps } from '@react-pdf/renderer';

// Basic parser for <br> and <strong> tags, the markup of the *_project_info_desc_pdf translations
export const parseHtmlToPdfText = (html: string, style?: TextProps['style']): React.ReactElement[] => {
    const withBreaks = html.replace(/<br\s*\/??\s*>/gi, '\n');
    const regex = /(<strong>(.*?)<\/strong>)/gi;
    const result: React.ReactElement[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let key = 0;

    while ((match = regex.exec(withBreaks)) !== null) {
        if (match.index > lastIndex) {
            const text = withBreaks.substring(lastIndex, match.index);
            if (text) {
                result.push(
                    <Text key={`plain-${key++}`} style={style}>
                        {text}
                    </Text>
                );
            }
        }

        const boldText = match[2];
        if (boldText) {
            result.push(
                <Text key={`bold-${key++}`} style={{ fontFamily: 'DejaVuSans', fontWeight: 'bold', ...style }}>
                    {boldText}
                </Text>
            );
        }
        lastIndex = regex.lastIndex;
    }

    if (lastIndex < withBreaks.length) {
        const text = withBreaks.substring(lastIndex);
        if (text) {
            result.push(
                <Text key={`plain-${key++}`} style={style}>
                    {text}
                </Text>
            );
        }
    }

    return result;
};
